<template>
  <div id="app" :style="'background-image:url('+bg+')'">
   <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>


export default {
  
  name: 'app',
  data () {
    return {
       bg:require('../static/README.png'),
    }
  },
  methods: {
      reload(){
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }

  },

  
}
</script>

<style>
html,body{
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
  .el-tooltip__popper[x-placement^=right] .popper__arrow{
      border-right-color: #1ab394 !important;
    }
    .el-tooltip__popper[x-placement^=right] .popper__arrow:after {
      border-right-color: #1ab394 !important;
    }
   .atooltip{
      background:  #1ab394 !important;
    }
   
    
 .el-upload--picture-card{
            height: 500px;
            width: auto;
            }
</style>
